export function resetStateReducer(state = {
  resetState: '',
  payLoad: {},
  fetching: false,
  fetched: false,
  type: '',
  errors: {}
}, action) {
  switch (action.type) {
    case 'PW_RESET_VALUE_PENDING': {
      return {
        ...state,
        payLoad: action.payLoad,
        fetching: true,
        fetched: false
      };
    }
    case 'PW_RESET_VALUE_FULFILLED': {
      return {
        ...state,
        resetState: action.payLoad.state,
        type: action.payLoad.reset_type,
        errors: {},
        fetching: false,
        fetched: true,
      };
    }
    case 'PW_RESET_VALUE_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}

export function verifyReducer(state = {
  state: '',
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'VERIFY_PIN_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: {},
      };
    }
    case 'VERIFY_PIN_FULFILLED': {
      return {
        ...state,
        state: action.payLoad.state,
        errors: {},
        fetching: false,
        fetched: true,
      };
    }
    case 'VERIFY_PIN_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}

export function questionsReducer(state = {
  question1: '',
  question2: '',
  question_id1: '',
  question_id2: '',
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'SEQ_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: {},
      };
    }
    case 'SEQ_FULFILLED': {
      return {
        ...state,
        question1: action.payLoad.data[0].attributes.name,
        question2: action.payLoad.data[1].attributes.name,
        question_id1: parseInt(action.payLoad.data[0].id, 10),
        question_id2: parseInt(action.payLoad.data[1].id, 10),
        errors: {},
        fetching: false,
        fetched: true,
      };
    }
    case 'SEQ_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}


export function answersReducer(state = {
  state: '',
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'VERIFY_ANSWERS_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: {},
      };
    }
    case 'VERIFY_ANSWERS_FULFILLED': {
      return {
        ...state,
        state: action.payLoad.state,
        errors: {},
        fetching: false,
        fetched: true,
      };
    }
    case 'VERIFY_ANSWERS_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}

export function newPasswordReducer(state = {
  fetching: false,
  fetched: false,
  errors: {}
}, action) {
  switch (action.type) {
    case 'NEW_PASSWORD_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: {},
      };
    }
    case 'NEW_PASSWORD_FULFILLED': {
      return {
        ...state,
        errors: {},
        fetching: false,
        fetched: true,
      };
    }
    case 'NEW_PASSWORD_REJECTED': {
      return {
        ...state,
        errors: action.payLoad.errors
      };
    }
    case 'NEW_PASSWORD_VIA_LINK_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: {},
      };
    }
    case 'NEW_PASSWORD_VIA_LINK_FULFILLED': {
      return {
        ...state,
        errors: {},
        fetching: false,
        fetched: true,
      };
    }
    default:
  }

  return {...state};
}

export function verifyResetLinkReducer(state = {
  fetching: false,
  fetched: false,
  linkValid: null,
  key: '',
  errors: {},
  user: {}
}, action) {
  switch (action.type) {
    case 'VERIFY_RESET_LINK_PENDING': {
      return {
        ...state,
        errors: {},
        key: action.payLoad
      };
    }
    case 'VERIFY_RESET_LINK_FULFILLED': {
      return {
        ...state,
        linkValid: true
      };
    }
    case 'VERIFY_RESET_LINK_REJECTED': {
      return {
        ...state,
        linkValid: false,
        errors: action.payLoad.errors
      };
    }
    default:
  }

  return {...state};
}



// WEBPACK FOOTER //
// ./src/reducers/resetReducer.js